// Cache busting utility for development mode
export const addCacheBuster = (url: string): string => {
  if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_NO_CACHE === 'true') {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_cb=${Date.now()}`;
  }
  return url;
};

// Force component re-render in development
export const forceRerender = (): number => {
  if (process.env.NODE_ENV === 'development') {
    return Date.now();
  }
  return 0;
};

// Add cache-busting to static assets
export const getAssetUrl = (path: string): string => {
  if (process.env.NODE_ENV === 'development') {
    return addCacheBuster(path);
  }
  return path;
};
